import React from "react"
import PropTypes from "prop-types"
import lottie from 'lottie-web'
import StandardModal from '../app_components/StandardModal'
import StandardButton from '../app_components/StandardButton'

class BadgeAlert extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      show: true,
      id: '',
    }

    this.confettiRef = React.createRef()
    this.confettiAnimation = null
    this.toggleAlert = this.toggleAlert.bind(this)
    this.loadLottie = this.loadLottie.bind(this)
    this.destroyLottie = this.destroyLottie.bind(this)
  }

  loadLottie() {
    if (!this.confettiRef.current || !this.props.confettiLottie) {
      return
    }

    this.destroyLottie()
    this.confettiAnimation = lottie.loadAnimation({
      container: this.confettiRef.current,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: this.props.confettiLottie,
    })
  }

  destroyLottie() {
    if (this.confettiAnimation) {
      this.confettiAnimation.destroy()
      this.confettiAnimation = null
    }
  }

  componentDidMount() {
    this.setState({
      show: true,
      id: this.props.badge.id,
    })
    this.loadLottie()
  }

  componentDidUpdate(prevProps) {
    if (this.state.id !== this.props.badge.id) {
      this.setState({
        id: this.props.badge.id,
        show: true,
      }, () => this.loadLottie())
    } else if (prevProps.confettiLottie !== this.props.confettiLottie) {
      this.loadLottie()
    }
  }

  componentWillUnmount() {
    this.destroyLottie()
  }

  toggleAlert() {
    this.setState({ show: false })

    if (this.props.preview) {
      if (this.props.onClose) {
        this.props.onClose()
      }
      return
    }

    this.props.deleteBadgeNotification(this.state.id)
    if (this.props.onDismissed) {
      this.props.onDismissed()
    }
  }

  render() {
    if (this.state.show === false) {
      return null
    }

    const { badge } = this.props.badge

    return (
      <StandardModal
        onClose={this.toggleAlert}
        title="New badge earned"
        modalClass="celebrationModal celebrationModal--badge"
        overlayClass="celebrationModalOverlay"
      >
        <div className="celebrationModal__confetti" ref={this.confettiRef} aria-hidden="true" />
        <div className="celebrationModal__content">
          <p className="celebrationModal__eyebrow">Congratulations!</p>
          <img
            className="celebrationModal__image celebrationModal__image--badge"
            src={badge.image_url}
            alt=""
          />
          <h2 className="celebrationModal__title">{badge.name}</h2>
          <p className="celebrationModal__body">{badge.body}</p>
          <StandardButton
            text="Awesome!"
            primary
            fullWidth
            onClick={this.toggleAlert}
          />
        </div>
      </StandardModal>
    )
  }
}

BadgeAlert.propTypes = {
  badge: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    badge: PropTypes.shape({
      name: PropTypes.string.isRequired,
      body: PropTypes.string,
      image_url: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  confettiLottie: PropTypes.string,
  deleteBadgeNotification: PropTypes.func,
  preview: PropTypes.bool,
  onClose: PropTypes.func,
  onDismissed: PropTypes.func,
}

BadgeAlert.defaultProps = {
  preview: false,
  deleteBadgeNotification: () => {},
}

export default BadgeAlert
